module.exports = __webpack_public_path__ + "img/shou2_ba3249fbf.png";